import type { CustomerBadgeTone } from '@/components/customer-portal/CustomerStatusBadge';
import type { CustomerJobStatusLabel } from '@/types/customer-job.types';

/**
 * Single source of truth for job status → badge tone, shared by
 * CustomerJobListPage and CustomerJobDetailPage (previously two duplicated
 * local STATUS_BADGE maps with raw hex color values). Declined uses the
 * `danger` tone per this session's explicit instruction — the prior
 * blueprint had left this as an open product decision (§23 item 7);
 * resolved here.
 */
export const JOB_STATUS_TONE: Record<CustomerJobStatusLabel, CustomerBadgeTone> = {
  Cancelled: 'neutral',
  Approved: 'success',
  Declined: 'danger',
  'Modification Requested': 'warning',
  'Decision Required': 'warning',
  'Service In Progress': 'primary',
  'Under Review': 'info',
  Received: 'neutral',
  Completed: 'success',
  'Status Unavailable': 'neutral',
};
